import React from 'react';
import Link from '~components/Link';

const GoogleMapsLink = ({ href, name }) => {
  return (
    <span>
        <i className="fa fa-map-marker-alt" />  <span className="monospace">Google Maps</span> — <Link href={href} target="_blank" rel="noopener noreferrer">{name}</Link>
    </span>
  );
};

export default GoogleMapsLink;